// Note for future Jason: this may not work with v-show els. Look at setting cached margin/paddings.

import Velocity from 'velocity-animate'

const DURATION = 250

const getComputedStyle = (el) => {
  if (document.defaultView && document.defaultView.getComputedStyle) return document.defaultView.getComputedStyle(el)
  return window.getComputedStyle(el)
}

const computePadding = (style) => {
  return {
    paddingTop: parseFloat(style.paddingTop) || 0,
    paddingBottom: parseFloat(style.paddingBottom) || 0
  }
}

const computeMargins = (style) => {
  return {
    marginTop: parseFloat(style.marginTop) || 0,
    marginBottom: parseFloat(style.marginBottom) || 0
  }
}

const removeStyles = (style) => {
  style.margin = null
  style.padding = null
}

export default {
  name: 'expand-transition',
  functional: true,
  render: (createElement, context) => {
    let data = {
      props: {
        name: 'expand-transition',
        css: false,
        mode: context.props.mode
      },
      on: {
        beforeEnter (el) {
          el.cachedOpacity = el.style.opacity
          el.style.opacity = 0
          el.cachedOverflowStyle = el.style.overflow
          el.style.overflow = context.props.overflow || 'hidden'
          el.cachedMaxHeight = el.style.maxHeight
          if (context.props.overflowEl) {
            context.props.overflowEl.cachedOverflowStyle = context.props.overflowEl.style.overflow
            context.props.overflowEl.style.overflow = 'hidden'
          }
        },

        enter (el, done) {
          const h = el.offsetHeight
          const computedStyle = getComputedStyle(el)

          const computedMargin = el.cachedMargin = computeMargins(computedStyle)
          el.style.marginTop = '0px'
          el.style.marginBottom = '0px'

          const computedPadding = el.cachedPadding = computePadding(computedStyle)
          el.style.paddingTop = '0px'
          el.style.paddingBottom = '0px'

          el.style.maxHeight = '0px'
          Velocity(el, {
            maxHeight: h,
            marginTop: computedMargin.marginTop,
            marginBottom: computedMargin.marginBottom,
            paddingTop: computedPadding.paddingTop,
            paddingBottom: computedPadding.paddingBottom,
            opacity: 1
          }, {
            duration: DURATION,
            complete: () => {
              el.style.overflow = el.cachedOverflowStyle
              if (context.props.overflowEl) {
                context.props.overflowEl.style.overflow = context.props.overflowEl.cachedOverflowStyle
              }
              el.style.maxHeight = el.cachedMaxHeight
              el.style.opacity = el.cachedOpacity
              if (context.props.removeStyles) removeStyles(el.style)
              done()
              const emitEvent = context.listeners.entercomplete
              if (emitEvent) emitEvent()
            }
          })
        },

        beforeLeave (el) {
          el.cachedOverflowStyle = el.style.overflow
          el.style.overflow = context.props.overflow || 'hidden'
          if (context.props.overflowEl) {
            context.props.overflowEl.cachedOverflowStyle = context.props.overflowEl.style.overflow
            context.props.overflowEl.style.overflow = 'hidden'
          }
          el.cachedMaxHeight = el.style.maxHeight
          el.style.maxHeight = `${el.offsetHeight}px`
        },

        leave (el, done) {
          Velocity(el, {
            maxHeight: '0px',
            marginTop: '0px',
            marginBottom: '0px',
            paddingTop: '0px',
            paddingBottom: '0px',
            opacity: 0
          }, {
            duration: DURATION,
            complete: () => {
              if (!context.props.keep) el.remove()
              el.style.maxHeight = el.cachedMaxHeight
              el.style.opacity = el.cachedOpacity
              el.style.overflow = el.cachedOverflowStyle
              if (context.props.overflowEl) {
                context.props.overflowEl.style.overflow = context.props.overflowEl.cachedOverflowStyle
              }
              if (context.props.removeStyles) removeStyles(el.style)
              done()

              const emitEvent = context.listeners.leavecomplete
              if (emitEvent) emitEvent()
            }
          })
        }
      }
    }

    return createElement('transition', data, context.children)
  }
}
